// extracted by mini-css-extract-plugin
module.exports = {"img":"ua_img__f6pe0","topBg":"ua_topBg__g_o1J"};